import type React from 'react';
import { ToggleButtonGroup, ToggleButton, Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  '& .MuiToggleButtonGroup-grouped': {
    margin: theme.spacing(0.5),
    border: 0,
    '&.Mui-disabled': {
      border: 0,
    },
    '&:not(:first-of-type)': {
      borderRadius: theme.shape.borderRadius,
    },
    '&:first-of-type': {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  '&.MuiToggleButton-root': {
    textTransform: 'none',
    padding: '4px 10px',
    fontSize: '0.8rem',
    fontWeight: 500,
    borderRadius: '16px',
    border: '1px solid',
    borderColor: theme.palette.divider,
  },
  '&.Mui-selected': {
    color: 'white',
    '&.pending': {
      backgroundColor: '#f59e0b',
      '&:hover': {
        backgroundColor: '#d97706',
      },
    },
    '&.approved': {
      backgroundColor: '#10b981',
      '&:hover': {
        backgroundColor: '#059669',
      },
    },
    '&.denied': {
      backgroundColor: '#ef4444',
      '&:hover': {
        backgroundColor: '#dc2626',
      },
    },
    '&.complete': {
      backgroundColor: '#3b82f6',
      '&:hover': {
        backgroundColor: '#2563eb',
      },
    },
  },
}));

interface StatusFilterButtonsProps {
  activeStatuses: string[];
  onChange: (statuses: string[]) => void;
}

const StatusFilterButtons = ({ activeStatuses, onChange }: StatusFilterButtonsProps) => {
  const handleStatusChange = (event: React.MouseEvent<HTMLElement>, newStatuses: string[]) => {
    onChange(newStatuses);
  };

  return (
    <Box sx={{ ml: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
        <Typography variant='body2' sx={{ mr: 2, fontWeight: 500 }}>
          Filter by status:
        </Typography>
        <StyledToggleButtonGroup value={activeStatuses} onChange={handleStatusChange} aria-label='status filter' size='small'>
          <StyledToggleButton value='pending' className='pending' aria-label='pending'>
            Pending
          </StyledToggleButton>
          <StyledToggleButton value='approved' className='approved' aria-label='approved'>
            Approved
          </StyledToggleButton>
          <StyledToggleButton value='denied' className='denied' aria-label='denied'>
            Denied
          </StyledToggleButton>
          <StyledToggleButton value='complete' className='complete' aria-label='complete'>
            Complete
          </StyledToggleButton>
        </StyledToggleButtonGroup>
      </Box>
    </Box>
  );
};

export default StatusFilterButtons;
